// All public image/SVG paths in one place.
// Vite serves the public/ folder at root.
// Favicon stays at root so browsers find it automatically.

export const CommonImages = {
    ECAL_LOGO:          '/assets/svgs/ecal-logo.svg',
    ECAL_SYMBOL:        '/assets/svgs/ecal-symbol.svg',
    FAVICON:            '/favicon.svg',
    // ecal-animated-bars.svg (v1) kept on disk as reference, not deleted —
    // this now points at the v2 asset (same fix applied: widened
    // viewBox/clipPath so the full bar composition renders with no dead
    // space or clipping).
    ECAL_ANIMATED_BARS: '/assets/svgs/ecal-animated-bars-v2.svg',
    // ECAL's standard loading indicator (the "connector dots"), matching the
    // one used across admin-v4-ui (src/components/LoadingAnimation).
    ECAL_LOADING_LOTTIE: '/assets/lottie/ecal-connector-lottie.lottie',
};

export default CommonImages;
